import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ag-sidebar ag-sidebar-scroll" }
const _hoisted_2 = { class: "ag-logo text-center ag-logo-fixed cursor-pointer" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/logo-text-part.svg",
  alt: "",
  width: "200"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ag_nav = _resolveComponent("ag-nav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/dashboard/company-overview/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    (_openBlock(), _createBlock(_component_ag_nav, {
      class: "ag-nav-fixed",
      data: _ctx.items,
      key: _ctx.store.getters.compKey
    }, null, 8, ["data"]))
  ]))
}